// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__ivW2y","listItem":"styles_listItem__Pgs0S","roleHint":"styles_roleHint__1kTDD","squareIcon":"styles_squareIcon__1sfCk"};